module.exports = __webpack_public_path__ + "img/1.6ff1dc4f.png";